import { FC } from 'react';

import { Text } from '@bonusly/design-system';

import { ValidationError } from '../../lib/validation';
import { useErrorText } from './hooks/use-error-text';

export const SingleError: FC<{ error: ValidationError }> = ({ error }) => {
	const t = useErrorText();

	return <Text>{t(error)}</Text>;
};
